<template>
  <div class="p-16">
    <base-button @click="$router.push({ name: 'edit-template' })" class="mb-8">
      <icon-plus-box title="Create new template" class="mr-2" />
      Create new template
    </base-button>

    <div v-if="changingSegment" class="mb-8 text-blue-400">
      <base-loading class="block text-3xl" />
      Loading templates
    </div>
    <template v-else>
      <template v-if="templates.length > 0">
        <h2 class="text-2xl mb-4">Templates</h2>

        <div v-if="lastChanged.template" class="bg-green-100 px-4 py-2 mb-4">
          <p v-if="lastChanged.type === 'edit'">
            <em>{{ lastChanged.template.name }}</em> saved successfully.
          </p>
          <p v-else-if="lastChanged.type === 'create'">
            <em>{{ lastChanged.template.name }}</em> created successfully.
          </p>
        </div>

        <div class="flex flex-wrap -mx-2 mb-8">
          <div
            v-for="template in templates"
            :key="template.id"
            class="w-1/3 p-2 flex"
            :class="lastChangedId === template.id ? 'shadow-highlight' : ''"
          >
            <button
              class="px-3 text-xl border-r border-gray-200 bg-white outline-none focus:outline-none hover:bg-blue-400 hover:text-white"
              @click="toggleTemplateFavorite(template.id)"
            >
              <icon-star v-if="template.is_favorite" title="Unfavorite" />
              <icon-star-outline v-else title="Favorite" />
            </button>
            <router-link
              :to="{
                name: 'create-link-from-template',
                params: { templateId: template.id },
              }"
              class="flex-1 flex items-center py-3 px-4 bg-white outline-none focus:outline-none hover:text-blue-400"
            >
              {{ template.name }}
            </router-link>
            <router-link
              :to="{
                name: 'edit-template',
                params: { templateId: template.id },
              }"
              class="flex items-center px-3 py-1 text-gray-600 hover:text-white hover:bg-blue-400 bg-gray-200"
            >
              <icon-edit title="Edit template" class="mr-2" />
              <span class="uppercase text-sm">Edit</span>
            </router-link>
          </div>
        </div>
      </template>

      <base-notice v-else>
        No templates created yet
      </base-notice>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
      currentSegmentId: (state) => state.company.segment.currentId,
      templates: (state) => state.company.segment.templates.list,
      lastChanged: (state) => state.company.segment.templates.lastChanged,
      changingSegment: (state) => state.company.segment.changingSegment,
    }),
    lastChangedId() {
      return this.lastChanged.template && this.lastChanged.template.id;
    },
  },
  destroyed() {
    this.$store.commit('company/segment/templates/resetLastChanged');
  },
  methods: {
    ...mapActions('company/segment/templates', ['toggleTemplateFavorite']),
  },
};
</script>
